import { useTranslation } from "react-i18next";
import Navbar from "../../components/navigation/Navbar";
import { ContextProvider } from "../../components/table/employees/Context";
import { Table } from "../../components/table/employees/Table";

const Employees = () => {
	const { t } = useTranslation('employees.page');

	return (
		<>
			<Navbar
				view={{
					title: t("title"),
					component: (
						<ContextProvider>
							<Table />
						</ContextProvider>
					),
				}}
				right={{
					title: "Right",
					component: <> componente </>,
				}}
			/>
		</>
	);
};

export { Employees };
